import { CandidateType } from '../features/candidates/Candidates.types';
import { useGetFetch } from '../utils/reactQuery';
import { pathToUrl } from '../utils/router';
import { ApiRoutesEnum } from '../utils/routes';

export const useGetCandidate = (id?: string) =>
  useGetFetch<CandidateType>({
    url: id ? pathToUrl(ApiRoutesEnum.getCandidate, { id }) : '',
    config: { enabled: !!id },
  });
